<template>
  <div v-if="showModal" class="onr-popup">
    <div class="onr-popup__modal" role="dialog" aria-modal="true" aria-labelledby="default-popup-title">
      <button class="onr-popup__close" type="button" aria-label="Close popup" @click="closeModal()">
        <svg height="15px" viewBox="0 0 512 512" width="15px">
          <path
              d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/>
        </svg>
      </button>

      <div class="onr-popup__art" aria-hidden="true">
        <img class="onr-popup__image" src="../../assets/korean-tutor.png" alt="">
      </div>

      <section class="onr-popup__content onr-popup__content--default">
        <span class="eyebrow onr-popup__eyebrow"><span class="dot"></span>The Dream</span>
        <h1 id="default-popup-title" class="onr-popup__title">Join us today!</h1>
        <p class="onr-popup__text">Let us build our dreams together!</p>
        <div class="onr-popup__actions">
          <button class="btn btn-primary" type="button" @click="handleSignUp()">Sign Up <span class="arr" aria-hidden="true">&rarr;</span></button>
          <button class="btn btn-ghost" type="button" @click="closeModal()">Later</button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'onr-popup',
  props: {
    showModal: Boolean,
    loggedIn: Boolean,
    variant: {
      type: String,
      default: 'default',
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    handleSignUp() {
      this.$emit('signup');
    },
  },
}
</script>

<style lang="scss">
// Rendered inside .tdi (SiteHeader). The .tdi prefix lets these beat the design's base
// h1 rule; the eyebrow and buttons use the design classes (.eyebrow, .btn) directly.
.tdi .onr-popup {
  align-items: center;
  background: rgba(22, 26, 63, .55);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  padding: 1.25rem;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;

  &__modal {
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: 22px;
    box-shadow: var(--shadow);
    display: grid;
    grid-template-columns: 240px minmax(0, 1fr);
    max-width: 720px;
    overflow: hidden;
    position: relative;
    width: 100%;
  }

  &__close {
    align-items: center;
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: 999px;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    position: absolute;
    right: 14px;
    top: 14px;
    width: 32px;
    z-index: 2;

    svg {
      fill: var(--ink-2);
    }
  }

  &__art {
    background: var(--navy);
    min-height: 320px;
    overflow: hidden;
    position: relative;

    &::after {
      background: rgba(241, 207, 99, .22);
      border-radius: 50%;
      content: '';
      height: 210px;
      left: -64px;
      position: absolute;
      top: -54px;
      width: 210px;
    }
  }

  &__image {
    bottom: 0;
    height: 100%;
    left: 50%;
    max-width: none;
    object-fit: cover;
    position: absolute;
    transform: translateX(-50%);
    width: 100%;
  }

  &__content {
    padding: 3rem 2.5rem 2.3rem;
    text-align: left;
  }

  &__eyebrow {
    display: inline-block;
    margin-bottom: 14px;
  }

  &__title {
    font-size: 36px;
    margin: 0;
  }

  &__text {
    color: var(--ink-2);
    margin: 14px 0 26px;
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  @media only screen and (max-width: 650px) {
    &__modal {
      grid-template-columns: 1fr;
      max-width: 360px;
    }

    &__art {
      display: none;
    }

    &__content {
      padding: 2.8rem 1.4rem 1.5rem;
      text-align: center;
    }

    &__title {
      font-size: 30px;
    }

    &__actions {
      justify-content: center;
    }
  }
}
</style>
